import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import { Row, Col } from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';
import JobCard from '../../components/JobCard';

export default function SimilarJobs({
    global,
    pathPrefix,
    customClass = "",
    content,
    buttonLink,
    buttonTitle,
    post,
    post_lang = ""
}) {
    return (
        post?.length >= 1 && (
            <section className={`${styles.root} ${customClass}`} >
                <Row className="mb-4 align-items-center">
                    <Col md={6}>
                        {content ?
                            <div className="mb-4 mb-md-0">
                                <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                    {content}
                                </SourceFlowText>
                            </div> : null}
                    </Col>
                    <Col md={6} className="d-flex justify-content-md-end">
                        {buttonLink ?
                            <Link href={`${buttonLink}`}>
                                <a className="primaryBtn no-arrow text-decoration-none">
                                    {buttonTitle}
                                </a>
                            </Link>
                            : null}
                    </Col>
                </Row>
                <Row>
                    {post?.map((job, index) => (
                        <Col lg={4} className="mb-4 mb-lg-0" key={index}>
                            <JobCard
                                {...job}
                                post_lang={post_lang}
                                slider={true}
                            />
                        </Col>
                    ))}
                </Row>
            </section>
        )
    )
}